/**
 * User Based Rules Constants.
 */
import { __ } from "@wordpress/i18n";

export const USER_BEHAVIOR = [
	{
		id: "LoggedIn",
		name: __("Logged In", "dxp"),
		typeID: "UserBehavior",
		details:
			"This rule applies to visitors that are logged in to your website.",
	},
	{
		id: "GuestUser",
		name: __("Guest User", "dxp"),
		typeID: "UserBehavior",
		details:
			"This rule applies to visitors that are not logged in to your website.",
	},
	{
		id: "NewUser",
		name: __("New Visitor", "dxp"),
		typeID: "UserBehavior",
		details: "This rule applies to visitors that are new to your website.",
	},
	{
		id: "Returning2",
		name: __("2nd Visit - Returning User", "dxp"),
		typeID: "UserBehavior",
		details:
			"This rule applies to visitors that are returning to your website for the second time.",
	},
	{
		id: "Returning3",
		name: __("3rd Visit - Returning User", "dxp"),
		typeID: "UserBehavior",
		details:
			"This rule applies to visitors that are returning to your website for the third time.",
	},
	{
		id: "ReturningCustom",
		multi: true,
		name: __("Custom # of Visits - Returning User", "dxp"),
		typeID: "UserBehavior",
		details:
			"This rule applies to visitors that are returning to your website for the number of times you configured above.",
	},
	{
		id: "UserRole",
		multi: true,
		name: __("User Role", "dxp"),
		typeID: "UserBehavior",
		premium: true,
		details:
			"This rule applies to logged-in visitors that have the user role you select above. <br> Learn more about WordPress user roles <a href='https://wordpress.com/support/invite-people/user-roles/' target='_blank' rel='nofollow' title='What are user roles?'>here</a>.",
	},
	{
		id: "UserMeta",
		multi: true,
		name: __("User Meta", "dxp"),
		typeID: "UserBehavior",
		premium: true,
		details:
			"This rule applies to logged-in visitors that have the WordPress metadata you select above linked to their account. <br> Learn more about WordPress metadata <a href='https://www.wpbeginner.com/glossary/metadata/' target='_blank' rel='nofollow' title='What is metadata?'>here</a>.",
	},
	{
		id: "SubmittedGravityForms",
		multi: true,
		name: __("Gravity Forms form submission", "dxp"),
		typeID: "UserBehavior",
		premium: true,
		details:
			"This rule applies to users who have responded to a Gravity Forms form on your website.",
	},
	{
		id: "ConvertKitCustomField",
		name: __("ConvertKit custom field", "dxp"),
		typeID: "UserBehavior",
		premium: true,
		details:
			"This rule applies to users who have a specific value in a custom field in ConvertKit.",
	},
	{
		id: "HubspotsProperties",
		name: __("HubSpot contact property", "dxp"),
		typeID: "UserBehavior",
		premium: true,
		details:
			"This rule applies to users who have a specific value in a property in HubSpot.",
	},
];

/**
 * WooCommerce Rules.
 */
export const WOOCOMMERCE = [
	{
		id: "Cart",
		name: __("WooCommerce Cart Not Empty", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "PurchaseOrder",
		name: __("Placed a WooCommerce order", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "CartProduct",
		multi: true,
		name: __("Specific product in cart", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "CartCategory",
		multi: true,
		name: __("Specific category in cart", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "TotalSpent",
		multi: true,
		name: __("User Orders Lifetime Value", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "PurchaseProduct",
		multi: true,
		name: __("Purchased a specific product", "dxp"),
		typeID: "UserBehavior",
		categoryID: "UserBased",
		premium: true,
	},
	{
		id: "PurchaseCategory",
		multi: true,
		name: __("Purchased a product from a specific category", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "NumberOfOrders",
		multi: true,
		name: __("# of orders placed", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "NumberOfItemsInCart",
		multi: true,
		name: __("# of items in WooCommerce cart", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "AverageOrderValue",
		multi: true,
		name: __("Average order value", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "ValueOfItemsInCart",
		multi: true,
		name: __("WooCommerce cart value", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "WooCommerceMembership",
		name: __("Has a WooCommerce membership", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
	{
		id: "WooCommerceSubscription",
		name: __("Has a WooCommerce subscription", "dxp"),
		typeID: "UserBehavior",
		premium: true,
	},
];
